import React, {useEffect,useContext} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction} from "mobx";
import PropTypes from "prop-types";
import {ComponentContext} from "../../contexts";

function ErrorRows(props) {
  const store = useLocalObservable(() => ({list: [], fetching: false, inited: false}));
  const compStore= useContext(ComponentContext);
  useEffect(() => {
    // mount

    return () => {
      // unmount
    }
  }, []);


  return (
    <div className="padd20">
      <h2>Строки с ошибками</h2>
      <table className="w100">
        <thead>
          <tr>
            <td>Номер строки</td>
            <td>Ошибка</td>
          </tr>
        </thead>
        <tbody>
        {compStore.submit_result.answer.error_rows.map((item)=>{
          return (
            <tr>
              <td>{item.row}</td>
              <td>{item.error}</td>
            </tr>
          )
        })}
        </tbody>
      </table>
    </div>
  )
};

ErrorRows.defaultProps = {};

ErrorRows.propTypes = {}

export default observer(ErrorRows);
